// Cart service object for centralized management
const AddItemOnTheFlyThroughURL = {
  // Add item to cart with proper error handling
  addItem: function (id, quantity = 1, isVariant = true) {
    const data = {
      items: [
        {
          quantity: quantity,
          id: id,
        },
      ],
    };

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    });
  },

  // Apply discount code to cart
  applyDiscount: function (discountCode) {
    if (!discountCode) return Promise.resolve();

    return fetch(`/discount/${discountCode}`, {
      method: 'GET',
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Failed to apply discount');
      }
      console.info('Discount applied successfully');
    });
  },

  // Get current cart state
  getCart: function () {
    return fetch('/cart.js').then((response) => response.json());
  },

  // Open cart drawer with animation
  openCartDrawer: function () {
    const $drawer = $('#CartDrawer');

    $drawer.parents('.js').addClass('js-drawer-open lock-scroll');
    $drawer.addClass('is-transitioning').attr('tabindex', '-1');

    setTimeout(() => {
      $drawer.removeClass('is-transitioning').addClass('drawer--is-open');
      document.dispatchEvent(new CustomEvent('cart:build'));
      UrlUtils.removeCartParameters();
    }, 400);
  },
};

// URL utility functions
const UrlUtils = {
  // Get parameter value from URL
  getParameter: function (name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);
    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '));
  },

  // Remove cart-related parameters from URL
  removeCartParameters: function () {
    const url = new URL(window.location.href);
    url.searchParams.delete('variant_id');
    url.searchParams.delete('product_id');
    url.searchParams.delete('discount_code');
    window.history.replaceState({}, document.title, url.href);
  },
};

// Handle auto-add to cart from URL parameters
function handleUrlParameterizedCart() {
  const variantId = UrlUtils.getParameter('variant_id');
  const productId = UrlUtils.getParameter('product_id');
  const discountCode = UrlUtils.getParameter('discount_code');

  let id, isVariant;

  if (variantId) {
    id = variantId;
    isVariant = true;
  } else if (productId) {
    id = productId;
    isVariant = false;
  } else {
    return; // No product specified, exit early
  }

  // Proceed with cart operations if we have a product
  if (id) {
    AddItemOnTheFlyThroughURL.addItem(id, 1, isVariant)
      .then(() => AddItemOnTheFlyThroughURL.applyDiscount(discountCode))
      .then(() => AddItemOnTheFlyThroughURL.openCartDrawer())
      .catch((error) => console.error('Cart operation failed:', error));
  }
}

// Run URL parameter handling after DOM is fully loaded
document.addEventListener('DOMContentLoaded', handleUrlParameterizedCart);

/***
 * Functions for cart management and UI updates
 * created by: Alex
 */
/**
 * Function to remove a free gift item from the cart by setting quantity to zero
 * @param {HTMLElement} element - The element that triggered the function
 * @param {string} productId - The product ID of the gift item to remove
 */
function removeFreeGift(element, productId) {
  // Add loading state to button
  $(element).addClass('btn--loading');

  // Find the line item key for this product in the cart
  $.ajax({
    url: '/cart.js',
    dataType: 'json',
    cache: false,
    success: function (cart) {
      // Find the line item with the matching product ID
      var lineItemKey = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].id == productId) {
          lineItemKey = cart.items[i].key;
          break;
        }
      }

      if (lineItemKey) {
        // Use CartJS to update quantity to 0 (remove item)
        CartJS.updateItemById(
          lineItemKey,
          0,
          {},
          {
            success: function (data, textStatus, jqXHR) {
              // Show success message
              showFreeGiftRemovalMessage('Gift removed from cart');

              // Refresh cart drawer content
              document.dispatchEvent(new CustomEvent('cart:build'));

              // Reload page if on cart page
              if (window.location.pathname.includes('/cart')) {
                window.location.reload();
              }
            },
            error: function (jqXHR, textStatus, errorThrown) {
              console.error('Error removing gift item:', errorThrown);
              $(element).removeClass('btn--loading');
            },
          }
        );
      } else {
        console.error('Could not find the gift item in cart');
        $(element).removeClass('btn--loading');
      }
    },
    error: function (xhr, status, error) {
      console.error('Error getting cart:', error);
      $(element).removeClass('btn--loading');
    },
  });
}

/**
 * Function to show a success message when a gift is removed
 * @param {string} message - The message to display
 */
function showFreeGiftRemovalMessage(message) {
  // Create the message element
  var $messageElement = $('<div class="jsc-free-gift-message"></div>').text(
    message
  );

  // Style the message
  $messageElement.css({
    position: 'fixed',
    top: '20px',
    right: '20px',
    'background-color': '#4caf50',
    color: 'white',
    padding: '15px',
    'border-radius': '4px',
    'z-index': '10000',
    'box-shadow': '0 2px 5px rgba(0,0,0,0.2)',
  });

  // Add to body
  $('body').append($messageElement);

  // Fade out and remove after delay
  setTimeout(function () {
    $messageElement.fadeOut(500, function () {
      $(this).remove();
    });
  }, 3000);
}

/**
 * Function to add an item to the cart
 * * @param {string} id - The product ID to add
 */
function addToCartProduct(e) {
  var $this = $(e);
  var $siblingThis = $this.siblings('.jsc-data-var-atb');
  var $varID = $siblingThis.attr('data-var-id');

  // Pass the button element to addToCart
  // The drawer opening logic has been moved into the success callback of addToCart
  addToCartItem($varID, 1, {}, $this);
}

/**
 * Function * to add an item to the cart
 * @param {string} id - The product ID to add
 * @param {number} quantity - The quantity to add
 * @param {object} obj - Additional properties to add with the item
 * @param {HTMLElement} buttonElement - The button element that triggered the function
 */
function addToCartItem(vid, qty, obj, buttonElement) {
  const $button = $(buttonElement);
  $button.addClass('btn--loading');

  // Use theme's existing cart add method
  fetch(theme.routes.cartAdd, {
    method: 'POST',
    body: JSON.stringify({
      id: vid,
      quantity: qty,
      properties: obj || {},
    }),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
    .then((response) => response.json())
    .then(function (data) {
      $button.removeClass('btn--loading');

      // Trigger cart update
      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data,
            addToCartBtn: buttonElement,
          },
        })
      );

      // If on cart page, reload
      if (window.location.pathname.includes('/cart')) {
        window.location.reload();
      }
    })
    .catch(function (error) {
      $button.removeClass('btn--loading');
      console.error('Error:', error);
    });
}
